import PropTypes from 'prop-types';

export const propTypes = {
  /**
   * Google Map Container Class Name
   *
   * @type {String}
   */
  mapContainerClassName: PropTypes.string,

  /**
   * List of locations
   *
   * @type {Array}
   */
  locations: PropTypes.array,

  /**
   * Selected Location Object
   *
   * @type {Object} Center LatLng { lat: 0.0, lng: 0.0 }
   */
  selectedLocation: PropTypes.object,

  /**
   * Hovered Location Object
   *
   * @type {Object} Center LatLng { lat: 0.0, lng: 0.0 }
   */
  hoveredLocation: PropTypes.object,

  /**
   * Show Current Device Location
   *
   * @type {Boolean} Show Current Device Location
   */
  showCurrentLocation: PropTypes.bool,

  /**
   * Center
   *
   * @type {Object} Center LatLng { lat: 0.0, lng: 0.0 }
   */
  center: PropTypes.object,
  /**
   * selectedLocationId
   *
   * @type {String} the Selected Location ID
   */
  selectedLocationId: PropTypes.string,
  /**
   * resetTimeStamp
   *
   * @type {Object} function that resets the timestamp, which controls when GM reners
   */
  resetTimeStamp: PropTypes.func,
  /**
   * breakpoint
   *
   * @type {Object} Breakpoint obj
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onDragEnd: PropTypes.func,
  onZoomChanged: PropTypes.func,
  onMarkerEvents: PropTypes.func,
  onFitBounds: PropTypes.func,
  breakpoint: PropTypes.object,
  onExpandLocation: PropTypes.func,
  isUserDraggedOrZoom: PropTypes.bool,
  isReservationFlow: PropTypes.bool,
  setExpandedTab: PropTypes.func,
  setMobileExpanded: PropTypes.func,
  onSelectLocation: PropTypes.func,
  handleSelectedLocation: PropTypes.func,
  hoveredLocationId: PropTypes.string,
  isVisible: PropTypes.bool,
  showLocationDetailTile: PropTypes.bool,
  zoom: PropTypes.number,
};
